import * as  React from 'react';
import PopupWrapper from '../Popup/PopupWrapper';
import PopupHeader from '../Popup/PopupHeader';
import PopupBody from '../Popup/PopupBody';
import PopupButtons from '../Popup/PopupButtons';
import PopupButton from '../Popup/PopupButton';
import PopupCancelButton from '../Popup/PopupCancelButton';
import { popupHeaderIcons } from '../../../services/mini/popupHeaderIcons';
import * as _ from 'lodash';
import Overlay from '../Overlay/Overlay';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';
import { useClosePopup } from '../../../hooks/useClosePopup';

type ConfirmPopup2Props = {
    title: string,
    message: string | ReactChildrenGeneralType,
    onClose: () => void;
    onOkBtnCb: () => void;
    okBtnLabel?: string,
    cancelBtnLabel?: string,
    midBtnLabel?: string,
    midBtnCbClass?: string,
    hideTitle?: boolean,
    hideCancelBtn?: boolean,
    midBtnWidth?: number,
    okBtnWidth?: number,
    type?: string,
    onMidBtnCb?: () => void;
}

export function ConfirmPopup2({
    title,
    message,
    okBtnLabel,
    cancelBtnLabel,
    midBtnLabel,
    midBtnCbClass,
    hideTitle,
    hideCancelBtn,
    midBtnWidth,
    okBtnWidth,
    type,
    onClose,
    onOkBtnCb,
    onMidBtnCb
}: ConfirmPopup2Props
) {

    useClosePopup(onClose);

    return <Overlay>
        <PopupWrapper className="confirm-popup">
            {!hideTitle && <PopupHeader
                title={title}
                titleIcon={type ? popupHeaderIcons[type] : null}
                onCancel={onClose} />}
            <PopupBody>
                {_.isString(message) ?
                    <div className={"confirm-popup_message"} dangerouslySetInnerHTML={{ __html: message as string }} /> :
                    <div className={"confirm-popup_message"}>
                        {message}
                    </div>
                }
                <PopupButtons>
                    {!hideCancelBtn && <PopupCancelButton label={cancelBtnLabel || 'Cancel'} action={onClose} />}
                    {midBtnLabel && <PopupButton label={midBtnLabel} action={onMidBtnCb} className={midBtnCbClass} width={midBtnWidth} />}
                    <PopupButton label={okBtnLabel || 'OK'} action={onOkBtnCb} width={okBtnWidth} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>
    </Overlay>
}

export default ConfirmPopup2;